import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useTickets() {
  const queryTickets = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/tickets/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const queryTicketComments = async (
    ticketId,
    filter,
    page,
    limit,
    project,
    sort
  ) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/tickets/${ticketId}/comments/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getTicket = async (ticketId) => {
    const result = await axios.get(`${apiUri}/api/v1/tickets/${ticketId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data.data;
  };

  const createTicket = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/tickets`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data.data;
  };

  const bookTicket = async (ticketId) => {
    const result = await axios.post(
      `${apiUri}/api/v1/tickets/${ticketId}/book`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const addComment = async (ticketId, comment, active = true) => {
    const _body = {
      comment,
      active,
    };

    const result = await axios.post(
      `${apiUri}/api/v1/tickets/${ticketId}/comments`,
      compress(JSON.stringify(_body)),
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const closeTicket = async (ticketId) => {
    const result = await axios.post(
      `${apiUri}/api/v1/tickets/${ticketId}/close`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const uploadTicketAttachments = async (ticketId, files) => {
    let data = new FormData();

    for (const image of files) {
      data.append("files", image, image.name);
    }

    const result = await axios.patch(
      `${apiUri}/api/v1/tickets/${ticketId}/attachments/upload`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          maxBodyLength: Infinity,
        },
      }
    );

    return result.data.data?.attachments;
  };

  const uploadTicketCommentAttachments = async (ticketId, commentId, files) => {
    let data = new FormData();

    for (const image of files) {
      data.append("files", image, image.name);
    }

    const result = await axios.patch(
      `${apiUri}/api/v1/tickets/${ticketId}/comments/${commentId}/attachments/upload`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          maxBodyLength: Infinity,
        },
      }
    );

    return result?.data?.data?.attachments;
  };

  const patchTicket = async (ticketId, body) => {
    const result = await axios.patch(
      `${apiUri}/api/v1/tickets/${ticketId}`,
      compress(JSON.stringify(body)),
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const patchTicketComment = async (ticketId, commentId, body) => {
    const result = await axios.patch(
      `${apiUri}/api/v1/tickets/${ticketId}/comments/${commentId}`,
      compress(JSON.stringify(body)),
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  return {
    queryTickets,
    getTicket,
    createTicket,
    queryTicketComments,
    bookTicket,
    addComment,
    closeTicket,
    uploadTicketAttachments,
    uploadTicketCommentAttachments,
    patchTicket,
    patchTicketComment,
  };
}
